import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "../lib/analytics";

export default function Install() {
  useEffect(() => {
    track("install_page_viewed", { page: "/install" });
  }, []);

  return (
    <div className="min-h-screen bg-[#080B14] text-white px-6 py-16">
      <div className="mx-auto max-w-xl">
        <div className="mx-auto mb-8 h-24 w-24 rounded-3xl bg-[#0C111D] p-3 ring-1 ring-[#D4AF37]/25">
          <img src="/logo.png" alt="Bora Moyo" className="h-full w-full object-contain" />
        </div>

        <h1 className="font-display text-4xl text-center mb-4">Install Bora Moyo</h1>
        <p className="text-white/60 text-center mb-8">
          Add Bora Moyo to your home screen for a faster, app-like experience.
        </p>

        <div className="glass rounded-3xl p-6 space-y-6">
          <div>
            <div className="text-[#D4AF37] font-semibold mb-2">iPhone / Safari</div>
            <ol className="text-white/70 text-sm space-y-2 list-decimal pl-5">
              <li>Tap the Share icon.</li>
              <li>Scroll and tap “Add to Home Screen.”</li>
              <li>Tap “Add.”</li>
            </ol>
          </div>

          <div className="border-t border-white/10 pt-6">
            <div className="text-[#D4AF37] font-semibold mb-2">Android / Chrome</div>
            <ol className="text-white/70 text-sm space-y-2 list-decimal pl-5">
              <li>Tap the menu ⋮.</li>
              <li>Tap “Install app” or “Add to Home screen.”</li>
              <li>Confirm install.</li>
            </ol>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link to="/" className="text-[#D4AF37] hover:text-[#F2DE94]">
            Back to Bora Moyo
          </Link>
        </div>
      </div>
    </div>
  );
}
